var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "avue-crud",
        _vm._g(
          _vm._b(
            {
              attrs: { page: _vm.page },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "refresh-change": _vm.refreshChange,
                "search-reset": _vm.searchChange,
                "search-change": _vm.searchChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "menu",
                  fn: function (ref) {
                    var row = ref.row
                    if (row === void 0) row = {}
                    return [
                      row.invoiceList &&
                      row.invoiceList.length > 0 &&
                      row.invoiceList[0].filePath &&
                      (row.brokerType == 2 || row.orderStatus != 5)
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.lookInvoice(row)
                                },
                              },
                            },
                            [
                              _vm._v("\n\t\t\t\t查看发票\n\t\t\t\t"),
                              _c(
                                "span",
                                {
                                  staticClass: "u-font-weight-bold",
                                  style: row.isDownload
                                    ? { color: "red" }
                                    : { color: "gray" },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t(" +
                                      _vm._s(
                                        row.isDownload ? "已下载" : "未下载"
                                      ) +
                                      ")\n\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.formData,
                callback: function ($$v) {
                  _vm.formData = $$v
                },
                expression: "formData",
              },
            },
            "avue-crud",
            _vm.bindVal,
            false
          ),
          _vm.onEvent
        )
      ),
      _c("show-pdf-dialog", { ref: "refPdf" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }